import { Injectable } from '@angular/core';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { DwoAppointemntSubCheckListViewModel } from '../business-entities/dwo-sub-check-list-detail-view-model';
import { DWOCheckListRequestModel } from '../business-entities/dwo-sub-check-list-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service'

@Injectable({
  providedIn: 'root'
})
export class DwoCheckListDataService {

  constructor(private dataService: DataService) { }
  getCheckList(param: DWOCheckListRequestModel): Promise<GenericResponse<Array<DwoAppointemntSubCheckListViewModel>>> {
    return this.dataService.Post<GenericResponse<Array<DwoAppointemntSubCheckListViewModel>>>(Urls.GetDwoCheckList, param).toPromise();
  }
}
